BinderLive = window.BinderLive = (function () {
    const selectors = {
        tbTable: '.events-table',
        tbEvent: '.events-table__body-row',

        tbFavstar: '[tb-favstar],[tb-favstar-fav]',
        tbCalendar: '[tb-calendar]',
        searchFavstar: '[search-favstar]',
        searchEvent: '[search-event]',

        vmSelectAll: '#sports-filter__select-all',
        vmSportsFilterItem: '.j-sports-filter-item',
        vmSportsFilterSelectButton: '.j-sports-filter-item-select-button',
        vmSportsFilterLinkButton: '.j-sports-filter-item-link-button',
        vmSportsFilterItemsContainer: '#vm-sports-filter-items',

        emptyBetplace: '#live-empty_betplace',
        cmSorting: '#cm-sorting',

        broadcastFilter: '#tv-broadcast-filter',
        visualizationFilter: '#visualization-filter',
        broadcastFilterFav: '#tv-broadcast-filter-fav',
        visualizationFilterFav: '#visualization-filter-fav',

        nestedEventsFilter: '#nested-events-filter',
        favNestedEventsFilter: '#fav-nested-events-filter',

        pageScrollbarContainer: '#m-page-content-scrollbar-scrollarea',

        removeAll: '#live_favs-remove_all'
    };

    const vmSelectedClass = 'm-selected';

    var bindUI = function (isFavorite) {
        var body = app.body;
        if (isFavorite === undefined) {
            isFavorite = false;
        }

        // toggle SportFilterItem v3.0
        $(document).on('click', selectors.vmSportsFilterItem + '[data-sport-type-id]', function (e) {
            e.stopImmediatePropagation();
            e.preventDefault();

            var container = $(this),
                sportId = container.data('sport-type-id');

            var isAllChecked = $(selectors.vmSportsFilterItemsContainer).find(selectors.vmSportsFilterItem + ':not(.m-selected)').length > 0 ? false : true;
            var filterItemsLength = $(selectors.vmSportsFilterItem).length;

            if (isAllChecked && filterItemsLength > 1) {
                container.addClass('m-loading');
                Ajax.postJson("/Live/EnableOnlyOneItem", {
                    data: {
                        sportId: sportId
                    },
                    doCallAjaxViewParsers: false,
                    success: function (resp) {
                        $(selectors.vmSelectAll).prop('checked', false);
                        app.ModeTableLive.clear();
                        $(selectors.vmSportsFilterItemsContainer).find(selectors.vmSportsFilterItem).removeClass('m-selected');
                        container.addClass('m-selected');

                        app.ModeTableLive.insertTable(resp.html);

                        container.removeClass('m-loading');
                    }
                });
            } else {
                toggleSportsFilterItem(sportId, container);
            }

            return false;
        });

        // toggle SportFilter v3.0
        body.on('click', selectors.vmSelectAll, function () {
            TableFetcherLive.stop();

            var that = $(this),
                removingAll = !that.prop('checked'),
                allItems = $(selectors.vmSportsFilterItemsContainer).find(selectors.vmSportsFilterItem);


            that.parent().parent().addClass('m-loading');
            Ajax.postJson("/Live/ToggleSportFilter", {
                doCallAjaxViewParsers: false,
                success: function () {
                    if (removingAll) {
                        app.ModeTableLive.clear();
                        that.prop('checked', false);
                        allItems.removeClass(vmSelectedClass);
                    }
                    else {
                        app.ModeTableLive.update();
                        that.prop('checked', true);
                        allItems.addClass(vmSelectedClass);
                    }
                    (app.ModeTableLive.count() === 0)
                        ? $(selectors.emptyBetplace).addClass('active')
                        : $(selectors.emptyBetplace).removeClass('active');
                    that.parent().parent().removeClass('m-loading');
                }
            });
            return false;
        });

        // <select> on 'live' page
        body.on('change', selectors.cmSorting, function () {
            Ajax.postJson("/Live/SetSortingType", {
                data: { sortingType: $(this).val() },
                doCallAjaxViewParsers: false,
                success: function () {
                    app.ModeTableLive.update();
                    (app.ModeTableLive.count() === 0) ? $(selectors.emptyBetplace).addClass('active') : $(selectors.emptyBetplace).removeClass('active');
                }
            });
            return false;
        });

        var handleBroadcastFilter = function (isFavorite, checkBoxValue) {
            Ajax.postJson("/Live/SetBroadcastFilter", {
                data: { isBroadcastFilter: checkBoxValue, isFavorite: isFavorite },
                doCallAjaxViewParsers: false,
                success: function () {
                    app.ModeTableLive.update();
                    (app.ModeTableLive.isEmpty()) ? $(selectors.emptyBetplace).addClass('active') : $(selectors.emptyBetplace).removeClass('active');
                }
            });
            return false;
        };

        var handleVisualizationFilter = function (isFavorite, checkBoxValue) {
            Ajax.postJson("/Live/SetVisualizationFilter", {
                data: { isVisualizationFilter: checkBoxValue, isFavorite: isFavorite },
                doCallAjaxViewParsers: false,
                success: function () {
                    app.ModeTableLive.update();
                    (app.ModeTableLive.isEmpty()) ? $(selectors.emptyBetplace).addClass('active') : $(selectors.emptyBetplace).removeClass('active');
                }
            });
            return false;
        };

        var handleNestedEventsFilter = function (isFavorite, checkboxValue) {
            Ajax.postJson("/Live/SetNestedEventsFilter", {
                data: { isFavorite: isFavorite, isNestedEventsFilter: checkboxValue },
                doCallAjaxViewParsers: false,
                success: function () {
                    app.ModeTableLive.update();
                }
            });
            return false;
        }

        // <input[checkbox]> on 'live' page for Broadcast and Visualization filters
        body.on('change', selectors.broadcastFilter, function () {
            handleBroadcastFilter(false, $(this).is(":checked"));
        });
        body.on('change', selectors.visualizationFilter, function () {
            handleVisualizationFilter(false, $(this).is(":checked"));
        });
        body.on('change', selectors.broadcastFilterFav, function () {
            handleBroadcastFilter(true, $(this).is(":checked"));
        });
        body.on('change', selectors.visualizationFilterFav, function () {
            handleVisualizationFilter(true, $(this).is(":checked"));
        });

        body.on('change', selectors.nestedEventsFilter, function () {
            handleNestedEventsFilter(false, $(this).is(":checked"));
        });

        body.on('change', selectors.favNestedEventsFilter, function () {
            handleNestedEventsFilter(true, $(this).is(":checked"));
        });

        // Fave/Unfave calendarEvent
        //TODO: Calendar is obsolete. Удалить после выхода единого события
        body.on('click', selectors.tbCalendar, function (e) {

            var that = $(this),
                eventId = that.closest(selectors.tbEvent).data('id'),
                dataIdFilter = '[data-id=' + eventId + ']',
                isRemovingFromFav = that.hasClass('m-active');

            that.addClass('m-loading');
            Ajax.postJson(isRemovingFromFav ? "/Calendar/UnFaveEvent" : "/Calendar/FaveEvent", {
                data: {
                    id: eventId
                },
                doCallAjaxViewParsers: false,
                success: function (resp) {
                    that.toggleClass('m-active');

                    if (resp && resp.Message) {
                        that.removeClass('m-active');
                        Tooltip.errorNode(that, resp.Message);
                        that.removeClass('m-loading');
                        return;
                    }

                    if (isRemovingFromFav) {
                        var currentEvent = $(selectors.tbEvent + dataIdFilter),
                            parentTable = currentEvent.closest(selectors.tbTable),
                            nestedEvents = $(`[data-meid="${eventId}"]`);
                        if(nestedEvents.length) {
                            nestedEvents.each(function() {
                                this.remove();
                            })
                        }
                        if (parentTable.find(selectors.tbEvent).length <= 1) {
                            ModeTableLive.removeTable(parentTable.data('sportid'));
                            (app.ModeTableLive.count() === 0) ? $(selectors.emptyBetplace).addClass('active') : $(selectors.emptyBetplace).removeClass('active');
                        }
                        currentEvent.remove();
                    }

                    app.VerticalMenu.changeFavorites();

                    that.removeClass('m-loading');
                }
            });

            return false;
        });

        // Fave event v3.0
        body.on('click', (selectors.tbFavstar + ',' + selectors.searchFavstar), function (e) {

            var that = $(this),
                isRemovingFromFav = that.hasClass('m-active'),
                eventId = (that.is(selectors.tbFavstar)) ? that.closest(selectors.tbEvent).data('id') : that.closest(selectors.searchEvent).data('id'),
                dataIdFilter = '[data-id=' + eventId + ']',
                allStars = $.merge($(selectors.tbEvent + dataIdFilter).find(selectors.tbFavstar), $(selectors.searchEvent + dataIdFilter).find(selectors.searchFavstar));

            that.addClass('m-loading');

            var url = isRemovingFromFav ? "/Live/UnFaveEvent" : "/Live/FaveEvent";
            if (isRemovingFromFav && that.is('[tb-favstar-fav]'))
                url = "/Live/UnFaveFavoriteEvent";

            Ajax.postJson(url, {
                data: {
                    id: eventId
                },
                doCallAjaxViewParsers: false,
                success: function (resp) {
                    if (resp && resp.Message) {
                        that.removeClass('m-active');
                        Tooltip.errorNode(that, resp.Message);
                        that.removeClass('m-loading');
                        return;
                    }

                    if (isRemovingFromFav) {
                        allStars.removeClass('m-active');
                        allStars.attr('bb-tool', window.Localization.getString('Scripts_Shared_Main.Accent_10', 'Добавить в избранное'));
                        if (isFavorite) {
                            var currentEvent = $(selectors.tbEvent + dataIdFilter),
                                parentTable = currentEvent.closest(selectors.tbTable),
                                nestedEvents = $(`[data-meid="${eventId}"]`);
                                if(nestedEvents.length) {
                                    nestedEvents.each(function() {
                                        this.remove();
                                    })
                                }

                            if (parentTable.find(selectors.tbEvent).length <= 1) {
                                ModeTableLive.removeTable(parentTable.data('sportid'));
                                if (app.ModeTableLive.count() === 0) {
                                    $(selectors.emptyBetplace).addClass('active');
                                    $(selectors.removeAll).hide();
                                }
                                else {
                                    $(selectors.emptyBetplace).removeClass('active');
                                }
                            }
                            else {
                                currentEvent.remove();
                            }
                        }
                    }
                    else {
                        allStars.addClass('m-active');
                        allStars.attr('bb-tool', window.Localization.getString('Scripts_Shared_Main.Accent_11', 'Удалить из избранного'));
                        if (isFavorite && that.is(selectors.searchFavstar)) {
                            TableFetcherLive.full();
                            //TODO: Здесь получать только betPlace() без вертикального меню. и возможно не использовать fetcher (лишние расчеты diff)
                            $(selectors.emptyBetplace).removeClass('active');
                            $(selectors.removeAll).show();
                        }
                    }

                    app.VerticalMenu.changeFavorites();

                    that.removeClass('m-loading');
                },
            });

            return;
        });


        ConfirmButton.init(
            selectors.removeAll,
            function () {},
            '/Live/UnFaveAll',
            function (resp) {
                app.ModeTableLive.destroyTables();

                if (app.ModeTableLive.count() === 0) {
                    $(selectors.emptyBetplace).addClass('active');
                    $(selectors.removeAll).hide();
                } else {
                    $(selectors.emptyBetplace).removeClass('active');
                    $(selectors.removeAll).show();
                }

                app.VerticalMenu.changeFavorites();
            }
        );

        (app.ModeTableLive.count() === 0) ? $(selectors.removeAll).hide() : $(selectors.removeAll).show();

    };

    var unBindUI = function () {
        app.body
            .off('click', (selectors.tbFavstar + ',' + selectors.searchFavstar))
            .off('click', selectors.tbCalendar)
            .off('click', selectors.vmSelectAll)
            .off('change', selectors.cmSorting);

        $(document).off('click', selectors.vmSportsFilterItem + '[data-sport-type-id]');
        ConfirmButton.dispose(selectors.removeAll);
    };

    var toggleSportsFilterItem = function (sportId, sportsFilterItemContainer, callback) {
        TableFetcherLive.stop();

        var removing = sportsFilterItemContainer.hasClass(vmSelectedClass),
            allItems = $(selectors.vmSportsFilterItemsContainer).find(selectors.vmSportsFilterItem),
            selectAllbtn = $(selectors.vmSelectAll);
        var that = $(this);

        sportsFilterItemContainer.addClass('m-loading');
        Ajax.postJson("/Live/ToggleSportFilterItem", {
            data: {
                sportId: sportId,
            },
            doCallAjaxViewParsers: false,
            success: function (resp) {

                var prevFilter;
                var insertAfterId;
                if (window.globalAppSettings.site === "unicom") {
                    app.ModeTableLive.clear();
                    that.prop('checked', false);
                    allItems.removeClass(vmSelectedClass);

                    prevFilter = sportsFilterItemContainer.prevAll('.' + vmSelectedClass);
                    insertAfterId = (prevFilter.length !== 0) ? prevFilter.data('sport-type-id') : undefined;
                    app.ModeTableLive.insertTable(resp.html, insertAfterId);
                    sportsFilterItemContainer.addClass(vmSelectedClass);
                } else {
                    if (removing) {
                        app.ModeTableLive.removeTable(sportId);
                        sportsFilterItemContainer.removeClass(vmSelectedClass);
                    }
                    else {
                        prevFilter = sportsFilterItemContainer.prevAll('.' + vmSelectedClass);
                        insertAfterId = (prevFilter.length !== 0) ? prevFilter.data('sport-type-id') : undefined;
                        app.ModeTableLive.insertTable(resp.html, insertAfterId);
                        sportsFilterItemContainer.addClass(vmSelectedClass);
                    }
                }

                selectAllbtn.prop('checked', (allItems.filter('.' + vmSelectedClass).length === allItems.length));
                (app.ModeTableLive.count() === 0) ? $(selectors.emptyBetplace).addClass('active') : $(selectors.emptyBetplace).removeClass('active');

                sportsFilterItemContainer.removeClass('m-loading');

                if (callback) callback();
            }
        });
    }

    var bind = function (justLoaded) { bindUI(); };
    var unBind = function () { unBindUI(); };
    var bindFavorites = function (justLoaded) { bindUI(true); };
    var unBindFavorites = function () { unBindUI(); };

    return {
        bind: bind,
        bindFavorites: bindFavorites,
        unBind: unBind,
        unBindFavorites: unBindFavorites,
        name: 'BinderLive',
        url: '/Live/GetViewSet',
    };
}());

ScopeLive = (function () {
    function init() {
        app.VerticalMenu.init();
        TableFetcherLive.setMode.standard();
        app.ModeTableLive.init();

        app.Search.init('live');
    }

    function dispose() {
        app.VerticalMenu.dispose();
        app.ModeTableLive.dispose();
    }

    var start = function (justLoaded) { init(); };
    var stop = function () { dispose(); };

    return {
        start: start,
        stop: stop,
        name: 'ScopeLive',
        url: 'LIVE',
        title: Localization.getString('Shared.Live', 'Лайв')
    };
}());
